// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { store, persistor } from './components/redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from 'react-helmet-async'; // 👈 Add this
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider> {/* 👈 Wrap everything */}
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </HelmetProvider>
);

reportWebVitals();